import { Badge } from "antd";
import styled from "styled-components";

const StyledBadge = styled(Badge)`
  .ant-badge-count {
    color: #fff; // badge text color
    box-shadow: 0 0 0 0px #000; // this is to remove "colorBorderBg"
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), var(--primary-color);
  }
`;

export default function TeamChannelPreview({ channel }) {
  const name = channel?.data?.name || channel?.data?.id || "random";
  const unreadCount = channel.countUnread();
  const unreadCountMessage = unreadCount > 0 ? `${unreadCount} unread messages` : null;
  return (
    <div className="channel-preview__item" title={name}>
      <p>{`# ${name}`}</p>
      <StyledBadge showZero={false} title={unreadCountMessage} count={unreadCount} />
    </div>
  );
}
